import axios from 'axios';
import { fetchAuthSession } from 'aws-amplify/auth';
import { isLocalMode } from './localMode.ts';

// Create axios instance
const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'https://your-api-gateway-url.execute-api.us-east-1.amazonaws.com/dev',
});

// Request interceptor to add Authorization header with JWT token
axiosInstance.interceptors.request.use(
  async (config) => {
    // Local no-AWS mode: there is no Cognito session. Skip the token fetch entirely
    // and send the request unauthenticated — the local backend does not require a JWT.
    if (isLocalMode()) {
      return config;
    }
    try {
      // Get the current session
      const session = await fetchAuthSession();

      // IMPORTANT: Use ID token for API Gateway Cognito authorizers
      // API Gateway validates ID tokens (token_use: "id"), not access tokens
      const idToken = session.tokens?.idToken?.toString();
      const accessToken = session.tokens?.accessToken?.toString();
      const token = idToken || accessToken;

      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }
    } catch (error) {
      console.error('[Axios] Error fetching auth session:', error);
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor - just pass through errors
// Let components and ProtectedRoute handle authentication errors
axiosInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    // Don't redirect on 401 - let the components handle it
    // ProtectedRoute will redirect to login if user is not authenticated
    return Promise.reject(error);
  }
);

export default axiosInstance;
